"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClimateImpact = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const constants_1 = require("../../../constants");
class ClimateImpact {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.CLIMATE_IMPACT;
        this.description = 'Decrease oxygen 1 step. Lose 1 plant for each set of 5 TR over 15 and influence (max 5 sets).';
        this.revealedDelegate = PartyName_1.PartyName.EMPOWER;
        this.currentDelegate = PartyName_1.PartyName.CENTRISTS;
    }
    resolve(game, turmoil) {
        const canDecreaseOxygen = game.getTemperature() !== constants_1.MAX_OXYGEN_LEVEL;
        if (canDecreaseOxygen)
            game.increaseOxygenLevel(game.getPlayers()[0], -1);
        game.getPlayers().forEach((player) => {
            const trSetsOver15 = Math.floor((player.getTerraformRating() - 15) / 5);
            const amount = Math.min(trSetsOver15, 5) + turmoil.getPlayerInfluence(player);
            if (amount > 0) {
                player.deductResource(Resources_1.Resources.PLANTS, amount, { log: true });
            }
        });
    }
}
exports.ClimateImpact = ClimateImpact;
//# sourceMappingURL=ClimateImpact.js.map